import React from 'react';
import PropTypes from 'prop-types';
import Sidebar from '../Sidebar';
import './styles.css';

class Content extends React.PureComponent {
  static propTypes = {
    children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
    dimmed: PropTypes.bool,
    onClick: PropTypes.func,
    notPaddedDimmed: PropTypes.bool,
  };

  render() {
    const { dimmed, notPaddedDimmed } = this.props;
    const paddedStyle = notPaddedDimmed ? '' : 'padded-dimmed';
    return (
      <Sidebar.Pusher dimmed={dimmed} styleName={dimmed ? 'no-scroll-dimmed' : paddedStyle} onClick={this.props.onClick}>
        { this.props.children }
      </Sidebar.Pusher>
    );
  }
}

export default Content;
